import styled, { css } from "styled-components";

export const Input = styled.input`
  padding: 4px 10px;
  border-radius: 4px;
  width: 100%;
  line-height: 28px;
  transition: all 0.2s;

  ${({ invalid }) =>
    invalid
      ? css`
          border: 1px solid red;
          &:focus {
            border: 1px solid red;
          }
        `
      : css`
          border: 1px solid hsl(0, 0%, 70%);
          &:focus {
            border: 1px solid #2684ff;
          }
        `}
`;
